import { BearingEnvelope, flipJustification } from '@paragon/contract-library';

export type FlippableBearingEnvelopeProperties = Pick<BearingEnvelope, 'leftPoint' | 'rightPoint' | 'justification'>;

export function flipBearingEnvelope(envelope: FlippableBearingEnvelopeProperties): FlippableBearingEnvelopeProperties {
  return {
    leftPoint: envelope.rightPoint,
    rightPoint: envelope.leftPoint,
    justification: flipJustification(envelope.justification),
  };
}
